export default __webpack_public_path__ + "static/media/book-title.1f9fcfd0.png";